import React, { useState } from "react";
import { t } from '../../../i18n';
import { Query, Mutation } from "react-apollo";
import queries from "../../../queries";
import { FormattedMessage } from "react-intl";
import ImageUploader from "../../uploaders/ImageUploader";
import PaletteColorPicker from "../../PaletteColorPicker";
import {withRouter} from "react-router-dom";
import PhotoboothCellStatsButton from "../PhotoboothCellStatsButton";
import PhotoboothCellPhotosZipButton from "../PhotoboothCellPhotosZipButton";
import EditorSection from "./EditorSection";

function PhotoboothGifCellEditorWrapper({...props}) {

  const {projectId} = props.match.params;

  const cell = props.cell || props.initialCellData;

  const language = props.language;

  if (!cell) {
    return <p>No cell data provided.</p>;
  }

  return (
    <Query query={queries.cells.photobooth_gif.get} variables={{ id: cell.id }}>
      {({ loading, error, data }) => {
        if (loading) return <p>{t('ui.common.loading')}</p>;
        if (error) return <p>Error: {error.message}</p>;
        if (!data) return null;
        if(!!language) {
          return <PhotoboothGifCellEditorInner projectId={projectId} language={language} initialCellData={{...data.photoboothGifCell, language}} />;
        }
        return <PhotoboothGifCellEditorInner projectId={projectId} initialCellData={data.photoboothGifCell} />;
      }}
    </Query>
  );
}

function PhotoboothGifCellEditorInner({ initialCellData, projectId, language }) {
  const [cellData, setCellData] = useState(initialCellData);

  if (!cellData) {
    return <p>No cell data provided.</p>;
  }

  return (
    <Mutation
      mutation={language ? queries.cells.i18n.update : queries.cells.photobooth_gif.update}
      refetchQueries={[
        { query: queries.cells.photobooth_gif.get, variables: { id: cellData.id } },
      ]}
    >
      {(updateCell, { loading: mutationLoading, error: mutationError }) => (
        <>
          {mutationError && <p>Error: {mutationError.message}</p>}

          {/* You can use the additional data here if you need it */}
          <Query query={queries.projects.getWithChildren} variables={{ id: projectId }}>
            {({ loading, error, data }) => {
              if (loading) return <p>Loading project data...</p>;
              if (error) return <p>Error loading project: {error.message}</p>;
              if (!data) return null;

              const {project} = data;
              // Use data.project here if needed, but don’t re-render the component
              return (
                <div className="tsk-editor-form">
                  {!language && (
                    <>
                      <EditorSection title={<FormattedMessage id="projects.photobooth.gif.cell.background_color" />}>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.background_color" /></label>
                          <PaletteColorPicker
                            palette={project.color_palette}
                            color={cellData.background_color}
                            onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, background_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                          />
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.text_color" /></label>
                          <PaletteColorPicker
                            palette={project.color_palette}
                            color={cellData.text_color}
                            onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, text_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                          />
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.button_download_background_color" /></label>
                          <PaletteColorPicker
                            palette={project.color_palette}
                            color={cellData.button_download_background_color}
                            onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, button_download_background_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                          />
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.button_download_text_color" /></label>
                          <PaletteColorPicker
                            palette={project.color_palette}
                            color={cellData.button_download_text_color}
                            onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, button_download_text_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                          />
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.button_retake_background_color" /></label>
                          <PaletteColorPicker
                            palette={project.color_palette}
                            color={cellData.button_retake_background_color}
                            onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, button_retake_background_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                          />
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.button_retake_border_color" /></label>
                          <PaletteColorPicker
                            palette={project.color_palette}
                            color={cellData.button_retake_border_color}
                            onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, button_retake_border_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                          />
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.button_retake_text_color" /></label>
                          <PaletteColorPicker
                            palette={project.color_palette}
                            color={cellData.button_retake_text_color}
                            onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, button_retake_text_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                          />
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.button_print_background_color" /></label>
                          <PaletteColorPicker
                            palette={project.color_palette}
                            color={cellData.button_print_background_color}
                            onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, button_print_background_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                          />
                        </div>
                      </EditorSection>

                      <EditorSection title={<FormattedMessage id="Share.Print" />}>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="Share.Email" /></label>
                          <input
                            type="checkbox"
                            value={cellData.email}
                            checked={cellData.email}
                            onChange={(e) => setCellData({ ...cellData, email: e.target.checked })}
                          />
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="Share.Qr_Code" /></label>
                          <input
                            type="checkbox"
                            value={cellData.qr_code}
                            checked={cellData.qr_code}
                            onChange={(e) => setCellData({ ...cellData, qr_code: e.target.checked })}
                          />
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="Share.Print" /></label>
                          <input
                            type="checkbox"
                            value={cellData.print}
                            checked={cellData.print}
                            onChange={(e) => setCellData({ ...cellData, print: e.target.checked })}
                          />
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="Share.cameralabel" /></label>
                          <input
                            type="text"
                            value={cellData.cameralabel}
                            onChange={(e) => setCellData({ ...cellData, cameralabel: e.target.value })}
                          />
                        </div>
                      </EditorSection>
                    </>
                  )}

                  <EditorSection title={<FormattedMessage id="projects.photobooth.gif.cell.description_text" />}>
                    <div className="tsk-input-line tsk-input-line--full">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.gif_uri" defaultMessage="GIF" /></label>
                      <ImageUploader
                        onUpload={(e) => {
                          setCellData({ ...cellData, gif_uri: e });
                        }}
                        value={cellData.gif_uri}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.button_take_text" /></label>
                      <input
                        type="text"
                        value={cellData.button_take_text}
                        onChange={(e) => setCellData({ ...cellData, button_take_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.button_retake_text" /></label>
                      <input
                        type="text"
                        value={cellData.button_retake_text}
                        onChange={(e) => setCellData({ ...cellData, button_retake_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.button_download_text" /></label>
                      <input
                        type="text"
                        value={cellData.button_download_text}
                        onChange={(e) => setCellData({ ...cellData, button_download_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.send_text" /></label>
                      <input
                        type="text"
                        value={cellData.send_text}
                        onChange={(e) => setCellData({ ...cellData, send_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.sent_text" /></label>
                      <input
                        type="text"
                        value={cellData.sent_text}
                        onChange={(e) => setCellData({ ...cellData, sent_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.look_text" /></label>
                      <input
                        type="text"
                        value={cellData.look_text}
                        onChange={(e) => setCellData({ ...cellData, look_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.description_text" /></label>
                      <input
                        type="text"
                        value={cellData.description_text}
                        onChange={(e) => setCellData({ ...cellData, description_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.conditions1_text" /></label>
                      <input
                        type="text"
                        value={cellData.conditions1_text}
                        onChange={(e) => setCellData({ ...cellData, conditions1_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.conditions2_text" /></label>
                      <input
                        type="text"
                        value={cellData.conditions2_text}
                        onChange={(e) => setCellData({ ...cellData, conditions2_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.send_by_email_text" /></label>
                      <input
                        type="text"
                        value={cellData.send_by_email_text || ''}
                        onChange={(e) => setCellData({ ...cellData, send_by_email_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.print_text" /></label>
                      <input
                        type="text"
                        value={cellData.print_text || ''}
                        onChange={(e) => setCellData({ ...cellData, print_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.printed_text" /></label>
                      <input
                        type="text"
                        value={cellData.printed_text || ''}
                        onChange={(e) => setCellData({ ...cellData, printed_text: e.target.value })}
                      />
                    </div>
                  </EditorSection>
                </div>
              );
            }}
          </Query>
          <button
            className="tsk-button"
            onClick={() => updateCell({ variables: { input: removeTypenameDeep(!language ? {
              id: cellData.id,
              send_email: cellData.send_email,
              gif_uri: cellData.gif_uri,
              background_color: cellData.background_color,
              text_color: cellData.text_color,
              button_download_background_color: cellData.button_download_background_color,
              button_download_text_color: cellData.button_download_text_color,
              button_retake_background_color: cellData.button_retake_background_color,
              button_retake_border_color: cellData.button_retake_border_color,
              button_retake_text_color: cellData.button_retake_text_color,
              button_print_background_color: cellData.button_print_background_color,
              button_download_text: cellData.button_download_text,
              button_retake_text: cellData.button_retake_text,
              button_take_text: cellData.button_take_text,
              send_text: cellData.send_text,
              sent_text: cellData.sent_text,
              look_text: cellData.look_text,
              description_text: cellData.description_text,
              conditions1_text: cellData.conditions1_text,
              conditions2_text: cellData.conditions2_text,
              send_by_email_text: cellData.send_by_email_text,
              print_text: cellData.print_text,
              printed_text: cellData.printed_text,
              print: cellData.print,
              cameralabel: cellData.cameralabel,
              qr_code: cellData.qr_code,
              email: cellData.email,
            } : {
              button_download_text: cellData.button_download_text,
              button_retake_text: cellData.button_retake_text,
              button_take_text: cellData.button_take_text,
              gif_uri: cellData.gif_uri,
              send_text: cellData.send_text,
              sent_text: cellData.sent_text,
              look_text: cellData.look_text,
              description_text: cellData.description_text,
              conditions1_text: cellData.conditions1_text,
              conditions2_text: cellData.conditions2_text,
              send_by_email_text: cellData.send_by_email_text,
              print_text: cellData.print_text,
              printed_text: cellData.printed_text,
              language_code: language.code,
              cell_id: cellData.id}) } })}
            disabled={mutationLoading}
          >
            {mutationLoading ? "Updating..." : "Update"}
          </button>

          <PhotoboothCellStatsButton cell={cellData} />
          <PhotoboothCellPhotosZipButton cell={cellData} />
        </>
      )}
    </Mutation>
  );
}

function removeTypenameDeep(obj) {
  if (Array.isArray(obj)) {
    return obj.map(removeTypenameDeep);
  } else if (obj !== null && typeof obj === 'object') {
    const newObj = {};
    for (const key in obj) {
      if (key !== '__typename') {
        newObj[key] = removeTypenameDeep(obj[key]);
      }
    }
    return newObj;
  }
  return obj;
}

export default withRouter(PhotoboothGifCellEditorWrapper);
